import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  validarComprovante
} from '../../api/pdfAPI';
import * as mensagem from '../../common/Mensagens';
import { RootState } from '../../app/store';

export interface ValidacaoComprovanteState {
  comprovante: {
    codigoValidacao: string;
    solicitante: string;
    dataEmissao: string;
    isValidado: boolean;
    pdf: any;
  };
  mensagem : string;
  passCode: string;
  temComunicacaoComAPI: boolean;
  versaoMinimaAceitavel: boolean;
  ativarMensagemErro: boolean;
}

const initialState: ValidacaoComprovanteState = {
  comprovante: {
    codigoValidacao: '',
    solicitante: '',
    dataEmissao: '',
    isValidado: false,
    pdf: [],
  },
  mensagem: '',
  passCode: '',
  temComunicacaoComAPI: false,
  versaoMinimaAceitavel: true,
  ativarMensagemErro: false,
};

export const getValidarComprovante = createAsyncThunk(
  'validacaoComprovante/validarComprovante',
  async (data: any) => {
    const comprovante = await validarComprovante(data);
    return comprovante;
  }
);

export const validacaoComprovanteSlice = createSlice({
  name: 'validacaoComprovante',
  initialState,
  reducers: {
    alterarCodigoSeguranca: (state, action) => {
      state.comprovante.codigoValidacao = action.payload;
    },
    alterarMensagem: (state, action) => {
      state.mensagem = action.payload;
    },
    atualizarPassCode: (state, action) => {
      state.passCode = action.payload;
    },
    reset: state => initialState,
    resetPassCode:(state, action) => {
      state.passCode = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getValidarComprovante.fulfilled, (state, action) => {
        state.mensagem = !action.payload.isValidado ? mensagem.MSG_ERRO_CHAVE_SEGURANCA_INVALIDA : '';
        state.comprovante = action.payload;
        state.temComunicacaoComAPI = true;
        state.ativarMensagemErro = false;
      })
      .addCase(getValidarComprovante.rejected, (state, action) => {
        if (
          action.error?.message &&
          (action.error?.message.includes(mensagem.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA) ||
            action.error?.message.includes(mensagem.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB))
        ) {
          state.versaoMinimaAceitavel = false;
        } else {
          state.temComunicacaoComAPI = false;
        }
        state.ativarMensagemErro = true;
      })
  },
});

export const {
  alterarCodigoSeguranca,
  atualizarPassCode,
  alterarMensagem,
  reset,
  resetPassCode
} = validacaoComprovanteSlice.actions;

export const selectPdf = (state: RootState) => state.validacaoComprovante.comprovante.pdf;
export const selectComprovante = (state: RootState) => state.validacaoComprovante.comprovante;
export const selectExibirMensagem = (state: RootState) => state.validacaoComprovante.mensagem;
export const selectPassCode = (state: RootState) => state.validacaoComprovante.passCode;
export const selectComunicacaoAPI = (state: RootState) => state.validacaoComprovante.temComunicacaoComAPI;
export const selectVersaoMinimaAceitavel = (state: RootState) => state.validacaoComprovante.versaoMinimaAceitavel;
export const selectAtivarMensagemErro = (state: RootState) => state.validacaoComprovante.ativarMensagemErro;

export default validacaoComprovanteSlice.reducer;
